<template>
  <div>
    <h4>Настройки</h4>
    <div class="razd"></div>
    <label>
      <span class="l_title">Режим игры</span>
      <Select2 v-model="params.mode" :options="modes" :settings="{multiple: false,minimumResultsForSearch: -1}" />
    </label>
    <div class="razd"></div>
    <label>
      <span class="l_title">Шагов:</span>
      <div class="plm">
        <div class="plm__button plm__button--minus" @click="addParam('-', 'min_steps')"></div>
        <input type="number" min="2" v-model="params.min_steps">
        <div class="plm__button plm__button--plus" @click="addParam('+', 'min_steps')"></div>
      </div>
    </label>
    <div class="razd"></div>
    <label>
      <span class="l_title">Скорость (секунд):</span>
      <div class="plm">
        <div class="plm__button plm__button--minus" @click="addSpeed('-')"></div>
        <input type="number" min="0.1" max="5" v-model="params.speed">
        <div class="plm__button plm__button--plus" @click="addSpeed('+')"></div>
      </div>
    </label>
    <label class="check_label">
      <input type="checkbox" class="uk-checkbox" v-model="params.sounds">
      <span>Звуки</span>
    </label>
    <label class="check_label">
      <input type="checkbox" class="uk-checkbox" v-model="params.show_reactions">
      <span>Анимации</span>
    </label>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Select2 from 'v-select2-component';

export default {
  name: "settings",
  components: { Select2 },
  watch: {
    params: {
      handler: function (newValue) {
        if (!this.ingame) {
          this.$emit('params_changed', this.params);
        }
      },
      deep: true
    },
  },
  data() {
    return {
      modes: [
        {
          id: 'words',
          text: 'Слова'
        },
        {
          id: 'table',
          text: 'Таблица'
        },
      ],
      params: ''
    }
  },
  props: {
    is_homework: ''
  },
  computed: {
    role() {
      return this.$store.state.user.role.code;
    },
  },
  methods: {
    addParam(val, param, unit){
      let prm = +this.params[param];
      if(val === '+'){
        prm += 1;
      } else if(val === '-' && prm > 1){
        prm -= 1;
      }

      this.params[param] = prm;
    },
    addSpeed(val){
      let speed = +this.params.speed;
      if(val === '+' && speed < 10){
        speed += 0.1;
      } else if(val === '-' && speed > 0.1){
        speed -= 0.1;
      }

      this.params.speed = speed.toFixed(1);
    },
  },
  mounted() {
    this.params = this.$store.state.train.strup_params;
  }
}
</script>